import useCountTargets from 'CampaignBuilder/components/Steps/Audience/useCountTargets'

export default function useValidateDashboard() {
  const fieldCount = useSel(s => _.values(s.dashboardFields.entities).filter(f => f.active).length)
  const { searchId } = useSel(s => s.dashboard)

  function validate() {
    const errors = []

    if (!searchId) {
      errors.push('You need to add an audience to the dashboard.')
    }

    if (!fieldCount || fieldCount === 0) {
      errors.push('You need to add at least one column to the dashboard.')
    }

    return errors
  }

  const errors = validate()
  const isValid = errors.length === 0

  return [isValid, errors]
}
